import React, { useState, useEffect, useRef } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import Axios from '../../config/axios';
import { Fragment } from 'react';
import { useForm, Controller } from "react-hook-form";
import Card from 'react-bootstrap/Card';
import { Empty, Table } from 'antd';

export default function ShowARDetailsSlider(props) {
    const [state, setState] = useState({
        showPane: false,
        dataLoaded: false
    });

    const [ARDetails, setARDetails] = useState([]);
    const [formattedBalance, setFormattedBalance] = useState([]);
    const { register, getValues, setValue, control, watch } = useForm();
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const [viewOnly, setViewOnly] = useState([]);
    const [exhibitor, setExhibitor] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState(['']);

    useEffect(() => {
        LoadARDetails();

    }, [props]);

    function LoadARDetails() {
        let postdata = {};

        postdata.company_id = props.selectedCustomerId;
        postdata.showcode = props.selectedShowCode;

        Axios.get(`/api/GetInvoiceTransactions`, {
            params: {
                company_id: props.selectedCustomerId,
                showcode: props.selectedShowCode
            }
        }).then(response => {
            console.log(response.data);

            const transactions = response.data;
            const balance = transactions.reduce((total, item) => {
                let amt = parseFloat(item.amount) || 0;

                if (item.type === 'PMT') {
                    amt *= -1;
                }

                return total + amt;
            }, 0);

            const fBalance = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(balance);

            setFormattedBalance(fBalance);

            setARDetails(response.data);

            setState({
                ...state,
                dataLoaded: true,
                showPane: props.showPane
            });

        }).catch(error => {
            console.log(error);
        });

    }

    function handlePaneClose() {
        hidePane();
    }

    function hidePane() {
        setState({
            ...state,
            showPane: false
        });

        setTimeout(() => {
            props.hidePane();
        }, 1000)
    }

    const columns = [
        {
            dataIndex: 'id',
            title: 'id',
            key: 'id',
            hidden: true
        }, {
            dataIndex: 'invoiceNumber',
            title: 'Invoice #',
            key: 'invoiceNumber'
        }, {
            dataIndex: 'date',
            title: 'Invoice Date',
            key: 'date',
            render: (value) => {
                if (!value) return '';

                const date = new Date(value);

                return date.toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                });
            }
        }, {
            dataIndex: 'type',
            title: 'Type',
            key: 'type'
        }, {
            dataIndex: 'typeDetail',
            title: 'Detail',
            key: 'typeDetail'
        }, {
            dataIndex: 'amount',
            title: 'Amount',
            key: 'amount',
            render: (value) => {
                if (value == null) return '';

                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(value);
            },
            align: 'right'
        }, {
            dataIndex: 'reference',
            title: 'Reference',
            key: 'reference'
        }, {
            dataIndex: 'miscText',
            title: 'Description',
            key: 'miscText'
        }
    ].filter(item => !item.hidden);

    const rowSelection = {
        selectedRowKeys,
        /*onChange: onSelectChange,*/
        columnWidth: 0, // Set the width to 0
        renderCell: () => "", // Render nothing inside
    };

    //const onSelectChange = (newSelectedRowKeys) => {
    //    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    //    setSelectedRowKeys(newSelectedRowKeys);
    //};

    return (
        <>
            <SlidingPane
                className='my-custom-closer'
                overlayClassName='showCard'
                isOpen={state.showPane}
                title={'AR Summary for ' + props.selectedShowName} 
                onRequestClose={handlePaneClose}
                width={'40%'}
                closeIcon={<i className="fas fa-chevron-right float-left"></i>}
            >
                <div className="slide-pane-body scrollableDiv">
                    <div>
                        {state.dataLoaded &&
                            <div className="form-group col-lg-12 col-12">
                                <div className="rcorners p-2">
                                    <h3 className="frame-heading">
                                        AR Detail Records
                                    </h3>

                                    <div className="col-sm-12 col-md-12 col-lg-12" disabled={viewOnly} >
                                        {ARDetails?.length === 0 ?
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                                <span>
                                                    No AR Detail records found for this show
                                                </span>
                                            } />
                                            :
                                            <Table className="custom-ant-selection"
                                                rowKey={item => item.id}
                                                rowSelection={rowSelection}
                                                hideSelectionColumn={true}
                                                bordered
                                                size="small"
                                                dataSource={ARDetails}
                                                columns={columns}
                                                pagination={false}
                                                //pagination={{
                                                //    defaultPageSize: 10,
                                                //    showSizeChanger: true,
                                                //    pageSizeOptions: ['10', '25', '50', '100'],
                                                //    showTotal: (total, range) => (
                                                //        <span className="color-dark-blue" style={{ left: 0, position: "absolute", fontSize: "large", fontWeight: "bold" }}>
                                                //            Showing {range[0]}-{range[1]} of {total}
                                                //        </span>
                                                //    )
                                                //}}
                                                //onRow={(record) => {
                                                //    return {
                                                //        onClick: () => {
                                                //            let selRows = [record.contact_id];
                                                //            setSelectedRowKeys([...selRows]);
                                                //        },
                                                //        onDoubleClick: (e) => {
                                                //            loadContactDetails(e, record);
                                                //        }
                                                //    }
                                                //}}
                                            />
                                        }
                                    </div>
                                </div>
                                <h3 className="frame-heading pt-2">
                                    Balance Due: {formattedBalance}
                                </h3>
                            </div>
                        }
                    </div>
                </div>

                <div className="modal-footer">
                    <div className="form-group col-12 padding-25-10">
                        <button className="btn btn-submit margin-left-15 float-right" onClick={handlePaneClose}>Close</button>
                    </div>
                </div>
            </SlidingPane>
        </>
    );
}